import { Routes, Route, Navigate } from 'react-router-dom';
import AppLayout from './components/layout/AppLayout.jsx';
import Login from './pages/Login.jsx';
import Dashboard from './pages/Dashboard.jsx';
import MapPage from './pages/Map.jsx';
import StyleEditor from './pages/StyleEditor.jsx';
import Datasets from './pages/Datasets.jsx';
import ApiKeys from './pages/ApiKeys.jsx';
import Users from './pages/Users.jsx';
import Settings from './pages/Settings.jsx';
import Logs from './pages/Logs.jsx';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<AppLayout />}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/map" element={<MapPage />} />
        <Route path="/style-editor" element={<StyleEditor />} />
        <Route path="/datasets" element={<Datasets />} />
        <Route path="/api-keys" element={<ApiKeys />} />
        <Route path="/users" element={<Users />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/logs" element={<Logs />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
